import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import DayCard from "../components/DayCard";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Grid from "@material-ui/core/Grid";
import LinkToGoogleFormIframe from "../components/LinkToGoogleFormIframe";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import ProgramCard from "../components/ProgramCard";
import { closeEnrollDialog, getClasses, getAutoPilotGroup, enrollUserToClass, getSurveyStatus } from "../redux/actions/dataActions";


const styles = {
  root: {
    minWidth: "275px",
  },
  center: {
    margin: "auto 1em auto 1em",
    minWidth: "275px",
  },
  containerCentral: {
    justifyContent: "center",
  },
  lightText: {
    fontWeight: "100",
  },
};

class programs extends Component {
  componentDidMount() {
    this.props.getClasses();
    this.props.getAutoPilotGroup();
    this.props.getSurveyStatus();
  }

  closeEnrollDialog = () => {
    this.props.closeEnrollDialog();
  };

  render() {
    const { classes } = this.props;
    const { programs, autopilot_group, survey_status, loading, isEnrollDialogOpen } = this.props.data;
    const noProgramMessage = <Typography>Hello Explorer! No programs currently available with your selection </Typography>

    let classList = !loading ? (
      programs.length > 0 ? programs.map((program, i) => <ProgramCard key={i} program={program} />) : noProgramMessage
    ) : (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </div>
    );


    let enrollDialogPopUp; 
    
    // If the user is in group 3 or 4, they would have to fill out 
    // a survey when trying to enroll in the class 
    if ((autopilot_group === 3 || autopilot_group === 4) && survey_status === false){ 
      enrollDialogPopUp = 
        <Dialog
          open={isEnrollDialogOpen}
          onClose={this.closeEnrollDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
                  Thanks for signing up for this program. To complete the enrollment process, please fill in the following form.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <LinkToGoogleFormIframe typography="body1" title="Enrollment" href="https://docs.google.com/forms/d/e/1FAIpQLSfkTtupPs1tszLN0YPA6Npahq-Ysyng9FVu7ug176qe1OYqhw/viewform" dayId="1">
              Go to Form
            </LinkToGoogleFormIframe>
            <Button
              onClick={this.closeEnrollDialog}
              variant="contained"
              color="secondary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
    } else {
      enrollDialogPopUp = 
      
      <Dialog
      open={isEnrollDialogOpen}
      onEnter={()=>{this.props.enrollUserToClass({ classId: this.props.data.programId });}}
      onClose={this.closeEnrollDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Congratulations! You have successfully enrolled in the program.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
              onClick={()=>{
                this.props.history.push('/curriculum')
              }}
              variant="contained"
              color="secondary"
          >
            Go to Program
          </Button>
          <Button
            onClick={()=>{
              this.closeEnrollDialog()
            }}
            variant="contained"
            color="secondary"
          >
            Close
          </Button>
        </DialogActions>
    </Dialog>
    };

    return (
      <Grid container className={classes.containerCentral}>
        <Grid item sm />
        <Grid item sm className={classes.center}>
          <Typography variant="h3">Programs</Typography>
          {classList}
          {enrollDialogPopUp}
        </Grid>
        <Grid item sm />
      </Grid>
    );
  }
}

programs.propTypes = {
  getClasses: PropTypes.func.isRequired,
  getAutoPilotGroup: PropTypes.func.isRequired,
  getSurveyStatus: PropTypes.func.isRequired,
  enrollUserToClass: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps, { getClasses, getAutoPilotGroup, getSurveyStatus, enrollUserToClass, closeEnrollDialog })(
  withStyles(styles)(programs)
);
